import { UseFormReturn } from 'react-hook-form';
import { ReactNode } from 'react';
import { FormSection, CustomEventsField } from '../base';
import { SectionHeader } from '../base/';
import { ResetEventsButton } from '../../reset-events-button';
import { isEqual, sortBy } from 'lodash';
interface Event {
  value: string;
  label: string;
}
interface CustomEventsFieldProps {
  form: UseFormReturn<any>;
  title?: string;
  eventsList: Event[];
  maxCount?: number;
  placeholder?: string;
  controlClassName?: string;
  resetButton?: ReactNode;
  getUserSelectedEvents?: () => string[];
}

export const CustomEventsSection = ({
  form,
  eventsList,
  maxCount,
  placeholder,
  controlClassName,
  getUserSelectedEvents
}: CustomEventsFieldProps) => {
  const handleReset = () => {
    const events = eventsList.map((event) => event.value);
    form.setValue('customEvents', events, {
      shouldDirty: getUserSelectedEvents
        ? !isEqual(sortBy(getUserSelectedEvents()), sortBy(events))
        : true
    });
  };
  return (
    <FormSection>
      <div className="flex items-center gap-4">
        <SectionHeader>Event Settings</SectionHeader>
        <ResetEventsButton onClick={handleReset} />
      </div>
      <CustomEventsField
        form={form}
        eventsList={eventsList}
        maxCount={maxCount}
        placeholder={placeholder}
        controlClassName={controlClassName}
        resetButton={handleReset}
      />
    </FormSection>
  );
};
